import { useThree, useFrame } from '@react-three/fiber'
import { Html, PresentationControls, useGLTF, PerspectiveCamera, ContactShadows, useTexture } from '@react-three/drei'
// import { useControls,button,} from 'leva'
// import { Perf } from 'r3f-perf';
import { useEffect, useState } from 'react'
import * as THREE from 'three';
import { useSpring, animated, } from '@react-spring/three';

export default function Experience(props)
{
    // ------ui menus and vaulues
    const [openToggle, setopenToggle] = useState(false);
    // const { htmlPos,distance } = useControls('htmlscreen',{ htmlPos:[0,0.238,-0.003], distance:0.12 })
    // const {phonePosDebug} = useControls('htmlscreen',{phonePos:[0,-0.51,0]})
    const {viewport} = useThree();
    const mobile = viewport.width<viewport.height? true:false
    // importing model
    const { nodes, materials } = useGLTF('/phone.glb')
    const phonetext = useTexture('/Bakedagx.webp');phonetext.flipY = false
    const phonemat = new THREE.MeshBasicMaterial({map:phonetext})
    // --------zoom animation
    // useControls({testprobs: button(() => console.log(props.zoomToggle) )})
    // const springcongig = useControls ({mass: 5, tension: 180, friction: 50,clamp:true})
    const {phoneRot,phonePos,cameraPOS} = useSpring({
        phoneRot: props.zoomToggle ? (openToggle? 0 : 0.4) : Math.PI*2,
        phonePos: props.zoomToggle ?(openToggle? [0,-0.77,0]:[0,-0.24,-0.74] ): [0,-0.51,0],
        cameraPOS:props.zoomToggle ?(mobile?[ 0.0, -0.22, 0.6 ]:[ 0.0, -0.12, 0.39 ]):[-0.38, -0.16, 1.32]  ,
        config: {mass: 5, tension: 180, friction: 50, clamp:true }    
        });
    //--------Start animation
    const {screenRot}= useSpring({
        screenRot:openToggle? 0.2269:Math.PI-0.01,
        config: {mass: 5, tension: 180, friction: 50,clamp:true}
    })

    //centre camera lookat
    useFrame((state) => {
        state.camera.lookAt(0,0,0) 
    })
   //custom scroll
    let iframe = document.querySelector("iframe");
    onwheel = (event) => {
    iframe = document.querySelector("iframe");
    iframe.contentWindow.scrollBy({
        top: event.deltaY,
        left: 0, behavior: "smooth", });};
    
    //useEffect
    useEffect(()=> {
        setTimeout(() => {
            setopenToggle(true);
            document.body.classList.add('bgchange')
          }, 500);
        // console.log('onepunch');
        },[])
return<>
    <group>
        <animated.group position={cameraPOS}>
            <PerspectiveCamera makeDefault/>
        </animated.group>
    </group>
    <PresentationControls
        enabled={true}
        global
        rotation={ [ 0, 0, 0 ] }
        polar={[-Math.PI / 3, Math.PI / 1.8]} // Vertical limits
        azimuth={[-Infinity, Infinity]} // Horizontal limits
        config={{ mass: 0.1, tension: 69, friction: 10, }} // Spring config
        snap={ { mass: 2, tension: 200,friction:10 } }
        speed={3}
    >
    <animated.mesh geometry={ nodes.base.geometry }material={phonemat}
    position={ phonePos}
    rotation-y={ phoneRot }>
        <animated.mesh geometry={nodes.screen.geometry} material={phonemat}
        position={[0,0.5181, 0.0172]}
        rotation-x={screenRot}>
            <Html
            occlude="blending" 
            transform
            wrapperClass="phonebad"
            distanceFactor={ 0.12 }
            position={ [0,0.238,-0.003] }>
            <iframe src="/2d.html" />
            </Html>
        </animated.mesh>
    </animated.mesh>
    </PresentationControls>
    <ContactShadows {...{position:[0, -0.54, 0], opacity:0.9, scale:5, blur:1.3, far:6, resolution:256,color:"#690000"}} />
    {/* <Perf position='top-left' /> */}
</>
}